import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Stack,
  TableHead,
  TableCell,
  TableRow,
  Typography,
  Table,
  TableBody,
  TableContainer,
  Paper,
  useTheme,
} from "@mui/material";

// コンポーネントの Props の型
type ManageBackupsUploadDialogProps = {
  open: boolean;
  handleClose: () => void;
  fileInputRef: React.RefObject<HTMLInputElement>;
  selectedFiles: File[];
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleOpenFileExplorer: () => void;
  handleUpload: () => Promise<void>;
};

const ManageBackupsUploadDialog: React.FC<ManageBackupsUploadDialogProps> = (
  props
) => {
  const theme = useTheme();
  const {
    open,
    fileInputRef,
    selectedFiles,
    handleClose,
    handleFileChange,
    handleOpenFileExplorer,
    handleUpload,
  } = props;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          maxWidth: "400px",
          minWidth: "400px",
          maxHeight: "500px",
          minHeight: "500px",
        },
      }}
    >
      <Box sx={{ backgroundColor: theme.palette.custom.sForm }}>
        <DialogTitle sx={{ pb: 0.2 }}>ファイルアップロード</DialogTitle>
        <DialogContent sx={{ pb: 0.5 }}>
          <Stack direction="column" spacing={1.5} sx={{ p: 1 }}>
            <input
              type="file"
              multiple // 複数ファイル選択を許可
              onChange={handleFileChange}
              style={{ display: "none" }}
              ref={fileInputRef}
            />
            <Button variant="contained" onClick={handleOpenFileExplorer}>
              ファイルを選択
            </Button>
            <TableContainer
              component={Paper}
              sx={{
                minHeight: 320,
                maxHeight: 320,
                overflowY: "auto",
                backgroundColor: theme.palette.custom.row,
              }}
            >
              <Table>
                <TableHead
                  sx={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: theme.palette.custom.tableHeader,
                    zIndex: 1,
                    color: "white",
                  }}
                >
                  <TableRow>
                    <TableCell
                      size="small"
                      sx={{
                        textAlign: "center",
                        verticalAlign: "middle",
                        color: "white",
                      }}
                    >
                      <Typography fontWeight="fontWeightBold">
                        選択されたファイル
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                {selectedFiles.length > 0 && (
                  <TableBody>
                    {selectedFiles.map((file) => (
                      <TableRow key={file.name}>
                        <TableCell>
                          {file.name} ({Math.round(file.size / 1024)} KB)
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ pt: 0.5 }}>
          <Button
            sx={{ width: "20vh" }}
            onClick={handleClose}
            variant="outlined"
            color="secondary"
          >
            キャンセル
          </Button>
          {selectedFiles.length > 0 && (
            <Button
              onClick={handleUpload}
              sx={{ width: "20vh" }}
              variant="contained"
              color="primary"
            >
              アップロード
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default ManageBackupsUploadDialog;
